import { APPRECIATION_SET_TOTAL } from '../../constant';

const appreciationTotal = (state = 0, action = {}) => {
  const { type, data } = action;
  if (type === APPRECIATION_SET_TOTAL) {
    return data;
  }
  return state;
};

export { appreciationTotal };
